var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_5206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 20.2502H12.75C12.336 20.2502 12 19.9157 12 19.5002C12 19.0847 12 4.91418 12 4.50018C12 4.08618 12.336 3.75018 12.75 3.75018H23.25C23.664 3.75018 24 4.08618 24 4.50018V19.5002C24 19.9157 23.664 20.2502 23.25 20.2502Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 8.25018H12.75C12.336 8.25018 12 7.91568 12 7.50018C12 7.08468 12.336 6.75018 12.75 6.75018H20.25C20.664 6.75018 21 7.08618 21 7.50018C21 7.91418 20.664 8.25018 20.25 8.25018Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 11.2502H12.75C12.336 11.2502 12 10.9157 12 10.5002C12 10.0847 12.336 9.75018 12.75 9.75018H20.25C20.664 9.75018 21 10.0862 21 10.5002C21 10.9142 20.664 11.2502 20.25 11.2502Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14.2502H12.75C12.336 14.2502 12 13.9157 12 13.5002C12 13.0847 12.336 12.7502 12.75 12.7502H20.25C20.664 12.7502 21 13.0862 21 13.5002C21 13.9142 20.664 14.2502 20.25 14.2502Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 17.2502H12.75C12.336 17.2502 12 16.9157 12 16.5002C12 16.0847 12.336 15.7502 12.75 15.7502H20.25C20.664 15.7502 21 16.0862 21 16.5002C21 16.9142 20.664 17.2502 20.25 17.2502Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2285 0.924399C13.0575 0.780399 12.828 0.720399 12.612 0.763899L0.612 3.0139C0.258 3.0799 0 3.3904 0 3.7504V20.2504C0 20.6104 0.2565 20.9209 0.612 20.9869L12.612 23.2369C12.6585 23.2459 12.7035 23.2504 12.75 23.2504C12.924 23.2504 13.0935 23.1904 13.2285 23.0779C13.401 22.9354 13.5 22.7239 13.5 22.5004V1.5004C13.5 1.2769 13.401 1.0669 13.2285 0.924399Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74561 15.8345C9.70661 16.178 9.43661 16.4525 9.09311 16.4945C9.06161 16.499 9.03161 16.5005 9.00011 16.5005C8.69111 16.5005 8.40911 16.3085 8.29811 16.0145L6.75011 11.8865L5.20211 16.0145C5.08211 16.3355 4.76711 16.532 4.41911 16.496C4.07861 16.46 3.80561 16.196 3.75761 15.8555L3.00761 10.6055C2.94911 10.1975 3.23411 9.81645 3.64361 9.75795C4.05461 9.69795 4.43411 9.98445 4.49261 10.394L4.82711 12.74L6.04661 9.48645C6.26561 8.90145 7.23161 8.90145 7.45211 9.48645L8.60111 12.5495L9.00461 8.91645C9.05111 8.50545 9.43211 8.20995 9.83261 8.25345C10.2451 8.30145 10.5406 8.67195 10.4956 9.08295L9.74561 15.8345Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_5206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/word-icon.23f6d07a664c1c1468742823cc18b7c7.svg";
export { ForwardRef as ReactComponent };